import marked from "marked";

let errMsg = '';
export { errMsg };

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export class Deferred {
  constructor() {
    this.reset();
  }
  reset() {
    this.promise = new Promise((resolve, reject) => {
      this.reject = reject
      this.resolve = resolve
    })
  }
}

export function changeTheme(theme = 'light') {
  if(theme == 'light') {
    document.body.classList.remove('dark-theme')
  } else {
    document.body.classList.add('dark-theme')
  }
  document.documentElement.style.setProperty(`--main-background-color`, `var(--${theme}-background-color)`)
  document.documentElement.style.setProperty(`--main-text-color`, `var(--${theme}-text-color)`)
  document.documentElement.style.setProperty(`--main-primary-color`, `var(--${theme}-primary-color)`)
}

export function string_to_slug(str = '') {
  str = str.trim();
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäåâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to = "aaaaaeeeeiiiioooouuuunc------";
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-"); // collapse dashes

  return str;
}

export function convertFilename(str = '') {
  return str
    .trim()
    .replace(/\s+/g, '_') // replace whitespace with _
    .replace(/[^a-zA-Z0-9 \-_.]/g, ''); // remove unwanted characters, keep dots
}

export function getWeek(dt) {
  let tdt = new Date(dt.valueOf());
  let dayn = (dt.getDay() + 6) % 7;
  tdt.setDate(tdt.getDate() - dayn + 3);
  let firstThursday = tdt.valueOf();
  tdt.setMonth(0, 1);
  if (tdt.getDay() !== 4) {
    tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7);
  }
  return 1 + Math.ceil((firstThursday - tdt) / 604800000);
}

export function worker(fn) {
  let blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
  let url = URL.createObjectURL(blob);
  return new Worker(url);
}

export const colors = [
  "red lighten-1",
  "red lighten-2",
  "pink lighten-2",
  "pink lighten-3",
  "purple lighten-3",
  "purple lighten-2",
  "deep-purple lighten-1",
  "deep-purple lighten-2",
  "indigo lighten-2",
  "indigo lighten-1",
  "blue darken-1",
  "blue lighten-1",
  "light-blue darken-1",
  "light-blue lighten-1",
  "cyan lighten-1",
  "cyan darken-1",
  "teal lighten-2",
  "teal lighten-1",
  "green lighten-2",
  "green lighten-1",
  "light-green darken-1",
  "light-green lighten-1",
  "lime darken-1",
  "lime darken-2",
  "amber lighten-2",
  "amber darken-1",
  "orange lighten-2",
  "orange lighten-3",
  "deep-orange lighten-1",
  "deep-orange lighten-2",
  "brown lighten-1",
  "blue-grey lighten-1",
  "blue-grey lighten-2"
];

export async function get(url, queryParamsObj) {
  return fetch2(url, 'GET', queryParamsObj);
}

export async function post(url, bodyObj, queryParamsObj) {
  return fetch2(url, 'POST', queryParamsObj, bodyObj);
}

export async function put(url, bodyObj, queryParamsObj) {
  return fetch2(url, 'PUT', queryParamsObj, bodyObj);
}

export async function deleteFetch(url) {
  return fetch2(url, 'DELETE');
}

export class Rest {
  static async get(entity, queryParamsObj) {
    return fetch2(`/rest/${entity}`, 'GET', queryParamsObj);
  }

  static async post(entity, bodyObj, queryParamsObj) {
    return fetch2(`/rest/${entity}`, 'POST', queryParamsObj, bodyObj);
  }

  static async put(entity, bodyObj, queryParamsObj) {
    return fetch2(`/rest/${entity}`, 'PUT', queryParamsObj, bodyObj);
  }

  static async delete(entity, _id) {
    return fetch2(`/rest/${entity}/${_id}`, 'DELETE');
  }
}

export class Api {
  static async get(url, queryParamsObj) {
    return fetch2(`/api/${url}`, 'GET', queryParamsObj);
  }

  static async post(url, bodyObj, queryParamsObj) {
    return fetch2(`/api/${url}`, 'POST', queryParamsObj, bodyObj);
  }

  static async put(url, bodyObj, queryParamsObj) {
    return fetch2(`/api/${url}`, 'PUT', queryParamsObj, bodyObj);
  }

  static async delete(url, queryParamsObj) {
    return fetch2(`/api/${url}`, 'DELETE', queryParamsObj);
  }
}

export async function fetch2(url, method, queryParamsObj, bodyObj = {}) {
  if (queryParamsObj) {
    const queryParams = encodeURIComponent(JSON.stringify(queryParamsObj));
    url += `?body=${queryParams}`;
  }

  const options = { method };
  if (method == 'POST' || method == 'PUT') {
    options.headers = { "Content-Type": "application/json" };
    options.body = JSON.stringify(bodyObj);
  }

  return await fetch(url, options).then(async response => {
    if (response.ok) {
      return response.json()
    } else {
      if (response.body) {
        errMsg = (await response.json()).error;
      }
      console.warn(`Url: ${url}`,
        (errMsg ? `\nError ${errMsg}` : '') +
        `\nQuery params:`, queryParamsObj,
        `\nOptions:`, options,
        `\nStatus: ${response.status} (${response.statusText})`);
    }
  });
}

export function addArticleSnippets() {
  fetch("/api/all-articles")
    .then(res => res.json())
    .then(res => {
      getAllArticles(res);
    });
}

function getAllArticles(articles) {
  for (let i = 0; i < articles.length; i++) {
    articles[i].snippet = addSnippet(articles[i]);
    // console.log(`${i} / ${articles.length} snippets added`);
    updateArticle(articles[i]);
  }
}

function addSnippet(article) {
  if (!article.content) {
    console.warn("article missing content:", article);
    return;
  }
  let div = document.createElement("div");
  div.innerHTML = marked(article.content.substr(0, 300));

  return div.innerText.replace(/\n/gm, " ");
}

function updateArticle(article) {
  fetch("rest/Article", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(article)
  });
}

export async function clearCache() {
  let keyList = await caches.keys();
  return Promise.all(
    keyList
      .map(key => {
        console.log("Removing old cache:", key);
        return caches.delete(key);
      })
  );
}
